<ui-web-page-title pageTitle="Event & Retreats" *ngIf="showPageTitle" class="container-fluid ui-web-page-title"></ui-web-page-title>
          
<div class="container-fluid ui-web-events__page">
    <div class="container">
        <div class="row">
            @for(item of events; track item; let count = $index) {
                <ui-web-event-card [event]="item" class="ui-web-event-card col-lg-4 col-12" [hideRegisterArea]="false"></ui-web-event-card>
            } @empty {
                <div class="col-12">
                    <div class="no-content-message">
                        <span class="icon-info icon"></span>
                        No Upcoming Events/Retreats Found.
                    </div>
                </div>
            }
        </div>
    </div>
</div>
            